import { Configuration, PublicClientApplication } from '@azure/msal-browser';

// 1. Get fundamental identifiers
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID || import.meta.env.VITE_B2C_CLIENT_ID;
const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID || import.meta.env.VITE_TENANT_ID;
const tenantSubdomain = import.meta.env.VITE_ENTRA_TENANT_SUBDOMAIN || import.meta.env.VITE_TENANT_SUBDOMAIN;
const tenantDomain = import.meta.env.VITE_ENTRA_TENANT_DOMAIN || import.meta.env.VITE_TENANT_DOMAIN;

// 2. Resolve Authority
let authority = import.meta.env.VITE_ENTRA_AUTHORITY || import.meta.env.VITE_CIAM_AUTHORITY || import.meta.env.VITE_B2C_AUTHORITY;

if (!authority) {
  if (tenantSubdomain) {
    // Looks like CIAM (Entra External ID)
    const domain = tenantDomain || (tenantId ? tenantId : `${tenantSubdomain}.onmicrosoft.com`);
    authority = `https://${tenantSubdomain}.ciamlogin.com/${domain}/v2.0`;
  } else if (tenantId || tenantDomain) {
    // Looks like standard Entra ID
    const target = tenantId || tenantDomain;
    authority = `https://login.microsoftonline.com/${target}/v2.0`;
  } else {
    // Fallback to common (not recommended for production but better than broken CIAM URL)
    authority = `https://login.microsoftonline.com/common/v2.0`;
  }
}

// Normalize authority: Ensure trailing /v2.0 and strip B2C policy segments
authority = authority.replace(/\/$/, '');
authority = authority.replace(/\/(B2C_\w+|b2c_\w+)$/i, '');
if (!/\/v2\.0\/?$/i.test(authority)) {
  authority = `${authority}/v2.0`;
}

// 3. Resolve Known Authorities (Host only)
const knownAuthorityHost = import.meta.env.VITE_ENTRA_KNOWN_AUTHORITY ||
  import.meta.env.VITE_CIAM_KNOWN_AUTHORITY ||
  (tenantSubdomain ? `${tenantSubdomain}.ciamlogin.com` : 'login.microsoftonline.com');

// 4. MSAL Configuration
const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: authority,
    knownAuthorities: [knownAuthorityHost],
    navigateToLoginRequestUrl: false,
    redirectUri: typeof window !== 'undefined' ? window.location.origin : (import.meta.env.VITE_FRONTEND_BASE_URL || 'http://localhost:5173'),
    postLogoutRedirectUri: typeof window !== 'undefined' ? window.location.origin : (import.meta.env.VITE_FRONTEND_BASE_URL || 'http://localhost:5173')
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true
  }
};

export const loginRequest = {
  scopes: [
    'openid',
    'profile',
    'offline_access'
  ]
};

export const msalInstance = new PublicClientApplication(msalConfig);